import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-file-size-asset',
  templateUrl: './global-file-size-asset.component.html',
  styleUrls: ['./global-file-size-asset.component.scss'],
})
export class GlobalFileSizeAssetComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
